module.exports = __webpack_public_path__ + "img/03.a6e3b3ad.jpg";